export default {"src":"/_next/static/media/tabs.1c75ecde.svg","height":495,"width":415,"blurWidth":0,"blurHeight":0};